import { ecorEnv } from '@/../environments/environment';
import { ParadataEventParam, ParadataEventService } from '@/common/paradata-event/paradata-event.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class AddCommentDialogHttpService {

    constructor(private httpClient: HttpClient,
        private paradataEventService: ParadataEventService) { }

    uploadFiles(formParam: any, formData: FormData, caseID: string): Observable<any> {
        const params = new URLSearchParams();

        for (const key in formParam) {
            params.set(key, formParam[key]);
        }

        caseID = encodeURIComponent(caseID.trim());

        const url = ecorEnv.apiEndpoint + '/secure/pega/cases/' + caseID + '/comments?' + params.toString();

        return this.httpClient.post<any>(url, formData, {
            reportProgress: true,
            observe: 'events',
            withCredentials: false,
        })
            .pipe(
                // catchError(this.handleError)
            );
    }


    private handleError(error: HttpErrorResponse) {
        console.error('surveys', 'error', error);
        if (error.error instanceof ErrorEvent) {
            console.error('surveys', 'client side error:', error.error.message);
        } else {
            return throwError('Error-111111');
        }
        return throwError('Error-222222');
    }
}
